// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loader-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.6); /* Optional: background overlay */
  z-index: 9999;
}

.lds-default {
  color: #ec4899; /* Pink color */
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}

.lds-default div {
  position: absolute;
  width: 6.4px;
  height: 6.4px;
  background: currentColor; /* Color set to pink */
  border-radius: 50%;
  animation: lds-default 1.2s linear infinite;
}

.lds-default div:nth-child(1) {
  animation-delay: 0s;
  top: 36.8px;
  left: 66.24px;
}
.lds-default div:nth-child(2) {
  animation-delay: -0.1s;
  top: 22.08px;
  left: 62.29579px;
}
.lds-default div:nth-child(3) {
  animation-delay: -0.2s;
  top: 11.30421px;
  left: 51.52px;
}
.lds-default div:nth-child(4) {
  animation-delay: -0.3s;
  top: 7.36px;
  left: 36.8px;
}
.lds-default div:nth-child(5) {
  animation-delay: -0.4s;
  top: 11.30421px;
  left: 22.08px;
}
.lds-default div:nth-child(6) {
  animation-delay: -0.5s;
  top: 22.08px;
  left: 11.30421px;
}
.lds-default div:nth-child(7) {
  animation-delay: -0.6s;
  top: 36.8px;
  left: 7.36px;
}
.lds-default div:nth-child(8) {
  animation-delay: -0.7s;
  top: 51.52px;
  left: 11.30421px;
}
.lds-default div:nth-child(9) {
  animation-delay: -0.8s;
  top: 62.29579px;
  left: 22.08px;
}
.lds-default div:nth-child(10) {
  animation-delay: -0.9s;
  top: 66.24px;
  left: 36.8px;
}
.lds-default div:nth-child(11) {
  animation-delay: -1s;
  top: 62.29579px;
  left: 51.52px;
}
.lds-default div:nth-child(12) {
  animation-delay: -1.1s;
  top: 51.52px;
  left: 62.29579px;
}

@keyframes lds-default {
  0%, 20%, 80%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.5);
  }
}
`, "",{"version":3,"sources":["webpack://./src/Styles/LoadingSpinner.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC,EAAE,iCAAiC;EACvE,aAAa;AACf;;AAEA;EACE,cAAc,EAAE,eAAe;EAC/B,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,wBAAwB,EAAE,sBAAsB;EAChD,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,aAAa;AACf;AACA;EACE,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,eAAe;EACf,aAAa;AACf;AACA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;AACd;AACA;EACE,sBAAsB;EACtB,eAAe;EACf,aAAa;AACf;AACA;EACE,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;AACd;AACA;EACE,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,eAAe;EACf,aAAa;AACf;AACA;EACE,sBAAsB;EACtB,YAAY;EACZ,YAAY;AACd;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,aAAa;AACf;AACA;EACE,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;AACF","sourcesContent":[".loader-wrapper {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(255, 255, 255, 0.6); /* Optional: background overlay */\n  z-index: 9999;\n}\n\n.lds-default {\n  color: #ec4899; /* Pink color */\n  display: inline-block;\n  position: relative;\n  width: 80px;\n  height: 80px;\n}\n\n.lds-default div {\n  position: absolute;\n  width: 6.4px;\n  height: 6.4px;\n  background: currentColor; /* Color set to pink */\n  border-radius: 50%;\n  animation: lds-default 1.2s linear infinite;\n}\n\n.lds-default div:nth-child(1) {\n  animation-delay: 0s;\n  top: 36.8px;\n  left: 66.24px;\n}\n.lds-default div:nth-child(2) {\n  animation-delay: -0.1s;\n  top: 22.08px;\n  left: 62.29579px;\n}\n.lds-default div:nth-child(3) {\n  animation-delay: -0.2s;\n  top: 11.30421px;\n  left: 51.52px;\n}\n.lds-default div:nth-child(4) {\n  animation-delay: -0.3s;\n  top: 7.36px;\n  left: 36.8px;\n}\n.lds-default div:nth-child(5) {\n  animation-delay: -0.4s;\n  top: 11.30421px;\n  left: 22.08px;\n}\n.lds-default div:nth-child(6) {\n  animation-delay: -0.5s;\n  top: 22.08px;\n  left: 11.30421px;\n}\n.lds-default div:nth-child(7) {\n  animation-delay: -0.6s;\n  top: 36.8px;\n  left: 7.36px;\n}\n.lds-default div:nth-child(8) {\n  animation-delay: -0.7s;\n  top: 51.52px;\n  left: 11.30421px;\n}\n.lds-default div:nth-child(9) {\n  animation-delay: -0.8s;\n  top: 62.29579px;\n  left: 22.08px;\n}\n.lds-default div:nth-child(10) {\n  animation-delay: -0.9s;\n  top: 66.24px;\n  left: 36.8px;\n}\n.lds-default div:nth-child(11) {\n  animation-delay: -1s;\n  top: 62.29579px;\n  left: 51.52px;\n}\n.lds-default div:nth-child(12) {\n  animation-delay: -1.1s;\n  top: 51.52px;\n  left: 62.29579px;\n}\n\n@keyframes lds-default {\n  0%, 20%, 80%, 100% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.5);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
